(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var nodes = document.querySelectorAll('[data-rev], [data-underline]');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (el) { io.observe(el); });
  }

  function countUp() {
    var blocks = document.querySelectorAll('[data-luca-count]');
    if (!blocks.length) return;

    function animate(el) {
      if (el.getAttribute('data-counted') === '1') return;
      el.setAttribute('data-counted', '1');
      var target = parseFloat(el.getAttribute('data-luca-count')) || 0;
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1500;
      var t0 = null;

      function tick(now) {
        if (!t0) t0 = now;
        var p = Math.min(1, (now - t0) / duration);
        p = 1 - Math.pow(1 - p, 3);
        var val = target * p;
        if (decimals > 0) {
          el.textContent = val.toFixed(decimals) + suffix;
        } else {
          el.textContent = Math.round(val).toLocaleString() + suffix;
        }
        if (p < 1) requestAnimationFrame(tick);
      }

      if (reduceMotion) {
        el.textContent = (decimals > 0 ? target.toFixed(decimals) : Math.round(target).toLocaleString()) + suffix;
        return;
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) {
      blocks.forEach(animate);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-luca-count]').forEach(animate);
          if (entry.target.hasAttribute('data-luca-count')) animate(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('[data-luca-count-root], [data-luca-count]').forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    document.body.classList.add('luca-redesign');
    reveal();
    countUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
